import algoliasearch from "algoliasearch"

import ENV from "../constants/env"

const client = algoliasearch(ENV.ALGOLIA_APP_ID ?? "", ENV.ALGOLIA_APP_KEY ?? "")
export default client